/**
 * DesignPanel — edits the RuntimeTheme + branding only (never components directly). Every
 * control maps 1:1 to a field of the frozen Theme/Branding contract, so changes flow
 * schema → Theme Resolver → Builder Engine and update the preview live, and reads its
 * value straight off the schema (no local/duplicated state) so the panel always shows
 * whatever is actually persisted.
 *
 * UI simplification: only Primary color, Brand assets (logo/favicon/logo size), and
 * Typography are exposed here. The following controls are intentionally HIDDEN, not
 * removed — their setters, schema fields, and runtime behavior are all still fully
 * intact (see `BuilderEditorContext.tsx`/`editorContext.ts`); they may be re-enabled by
 * restoring their JSX here, no other code changes needed:
 *   - Brand color (`setBrandColor` / `branding.brandColor`)
 *   - Style language / design system (`setDesignSystem` / `theme.designSystem`) — schemas
 *     keep whatever value they already have (AI-generated or previously manually set);
 *     there is simply no more UI to change it.
 *   - Radius (`setBorderRadius` / `theme.borderRadius`)
 *   - Density / spacing (`setSpacing` / `theme.spacing`)
 * A freshly generated (never manually saved) schema already renders with the reference
 * defaults for radius/spacing/typography (medium/normal/Inter — see `REFERENCE_THEME` in
 * themeVars.ts and `buildInitial` in BuilderEditorContext.tsx), so hiding these pickers
 * simply removes the ability to deviate from that default going forward — no schema,
 * runtime, or theme-contract change was made to achieve this.
 */
import { useBuilderEditor } from './editorContext'
import { Fieldset, ColorField} from './controls'

export function DesignPanel() {
  const e = useBuilderEditor()
  const { theme } = e.schema

  return (
    <div>

      <Fieldset title="Colors">
        <ColorField label="Primary color" value={theme.primaryColor} onChange={e.setPrimaryColor} />
        <p className="text-[11px] leading-relaxed text-gray-400">
          Drives the navbar, footer, buttons, links and active states across the whole
          site.
        </p>
      </Fieldset>

    </div>
  )
}
